<template>
  <div class="row">
    <div class="col-12">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body" style="padding: 2.5rem">
          <div class="text-center">
            <!--
            <h2>
              <span>Create Profile</span>
              <h6 class="heading-small text-muted py-3text-truncate">
                <span>Help us get to know you better!</span>
              </h6>
            </h2> -->
          </div>
          <br />

          <div class="row">
            <div class="col-12 col-sm-12">
              <div>
                <a-steps :current="currentStep" style="border-bottom: 1px solid #e0e0e0" class="py-2 mb-3" size="small">
                  <a-step v-for="(step, stepIndex) of steps" :key="stepIndex" :forceRender="true" />
                </a-steps>
              </div>
              <div>
                <div class="text-center">
                  <h4>{{ title }}</h4>
                </div>
                <!-- <span><b-spinner small></b-spinner> Processing ...</span> -->
                <div v-if="currentStep == 0">
                  <MobileNumberOTPVue
                    @proceed-next="increaseCurrentStep"
                    ref="mobileNo"
                    :clpSitePageSettings="clpSitePageSettings"
                  />
                </div>

                <div v-if="currentStep == 1">
                  <MembershipDetailsVue
                    ref="memberTypes"
                    :data="formData"
                    :clpSitePageSettings="clpSitePageSettings"
                    @tinVerified="tinVerified"
                    @verifyValue="verifyValue"
                  />
                </div>
                <div v-if="currentStep == 2">
                  <CompanyDetailsVue
                    ref="companyDetails"
                    :data="formData"
                    :clpSitePageSettings="clpSitePageSettings"
                    @tinVerified="tinVerified"
                    @verifyValue="verifyValue"
                  />
                </div>
                <div v-if="currentStep == 3">
                  <PersonalInformationVue ref="personalInfo" :data="formData" />
                </div>
                <div v-if="currentStep == 4">
                  <ContactInformationVue ref="address" :data="formData" />
                </div>

                <div v-if="currentStep == 5">
                  <SetPasswordVue ref="setPassword" :data="formData" @password-updated="onPasswordTyping" />
                </div>
                <div v-if="currentStep == 6">
                  <UploadDocumentsVue ref="uploadDocuments" :data="formData" />
                </div>
                <div v-if="currentStep == 7">
                  <TermsAndAgreementsVue
                    :clpSitePageSettings="clpSitePageSettings"
                    ref="termsAndAgreements"
                    :data="formData"
                    @can-create="changeCreateDisable"
                    @set-email-subscribe="changeEmailSubscribe"
                    @set-termsAndConditions="changeTermsAndCondition"
                  />
                </div>
              </div>

              <hr />
              <div class="container mx-0 px-0">
                <div class="row">
                  <div class="col-auto mr-auto">
                    <div v-if="currentStep != 0">
                      <template v-if="currentStep > 1">
                        <b-button size="sm" variant="primary" @click="decreaseCurrentStep()"> Previous </b-button>
                      </template>
                      <template
                        v-if="
                          currentStep >= 0 &&
                          currentStep < currentStepLimit - 1 &&
                          tinValidated === true &&
                          !checkValidation
                        "
                      >
                        <b-button
                          size="sm"
                          variant="primary"
                          @click="increaseCurrentStep()"
                          :disabled="currentStep === 5 && !isPasswordValid"
                        >
                          Next
                        </b-button>
                      </template>
                    </div>
                  </div>
                  <div class="col-auto">
                    <template v-if="currentStep === currentStepLimit - 1">
                      <div>
                        <b-overlay
                          :show="createLoading"
                          rounded
                          opacity="0.6"
                          spinner-small
                          spinner-variant="primary"
                          class="d-inline-block"
                        >
                          <b-button
                            ref="button"
                            size="sm"
                            variant="success"
                            @click="createMember()"
                            :disabled="!canCreate || createLoading"
                          >
                            Register
                          </b-button>
                        </b-overlay>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal :visible="reOtpModal" :footer="null" :closable="false" :mask="true" :maskClosable="false">
      <ReOtpVue ref="reOtp" :data="formData" :clpSitePageSettings="clpSitePageSettings" @reotp-success="reOtpSucess" />
    </a-modal>
    <a-modal :visible="corpModal" :footer="null" @cancel="closeModal">
      <p>Thank you for signing up, {{ this.formData.firstName }}!</p>
      <p>
        Your registration as Corporate-Retail Account application is currently on hold and pending approval. Please
        check your email within 5 working days for an update on your application status.
      </p>
    </a-modal>
    <a-modal :visible="retailModal" :footer="null" @cancel="closeModal">
      <p>Thank you for signing up, {{ this.formData.firstName }}!</p>
      <p>
        Please verify your email address to start earning points with the CWHD Rewards Program. A verification link has
        been sent to your registered email address.
      </p>
    </a-modal>
    <a-modal :visible="profModal" :footer="null" @cancel="closeModal">
      <p>Thanks for signing up, {{ this.formData.firstName }}!</p>
      <p>
        You have been registered as a Retail Account user while your application for Professional Account is pending
        approval. Please check your email within 72 hours for an update on your application status. A verification link
        has been sent to your registered email address. Please verify your email address to start earning points with
        CWHD Rewards Program.
      </p>
    </a-modal>
  </div>
</template>
<script>
import PersonalInformationVue from './partials/PersonalInformation.vue';
import MembershipDetailsVue from './partials/MembershipDetails.vue';
import MobileNumberOTPVue from './partials/MobileNumberOTP.vue';
import ContactInformationVue from './partials/ContactInformation.vue';
import CompanyDetailsVue from './partials/CompanyDetails.vue';
import SetPasswordVue from './partials/SetPassword.vue';
import UploadDocumentsVue from './partials/UploadDocuments.vue';
import TermsAndAgreementsVue from './partials/TermsAndAgreements.vue';
import axios from 'axios';
import HTTPRequest from '../../controllers/httpRequest';
import ReOtpVue from './partials/ReOtp.vue';
import moment from 'moment-timezone';

const S3Api = process.env.VUE_APP_CLP_S3_API;
const S3ApiKey = process.env.VUE_APP_CLP_S3_API_KEY;

export default {
  name: 'Registration',
  props: {
    clpSitePageSettings: Object,
  },
  components: {
    MobileNumberOTPVue,
    MembershipDetailsVue,
    PersonalInformationVue,
    ContactInformationVue,
    CompanyDetailsVue,
    SetPasswordVue,
    UploadDocumentsVue,
    TermsAndAgreementsVue,
    ReOtpVue,
  },
  data() {
    return {
      reOtpModal: false,
      createLoading: false,
      canCreate: false,
      retailModal: false,
      profModal: false,
      corpModal: false,
      windowWidth: window.innerWidth,
      currentStep: 0,
      isPasswordValid: false,
      formData: {
        optionalFilesCode: ['BIR_TAX'],
        files: [],
        mobileNo: null,
        memberTypeId: null,
        subMemberTypeId: null,
        chapterTypeId: null,
        firstName: null,
        middleName: null,
        lastName: null,
        lastNameSuffix: null,
        nickName: null,
        gender: null,
        birthDay: null,
        email: null,
        locationUnit: '',
        locationStreet: '',
        locationBarangay: '',
        barangayCode: null,
        locationCity: '',
        cityCode: null,
        locationMunicipality: '',
        municipalityCode: null,
        locationProvince: '',
        provinceCode: null,
        locationRegion: '',
        regionCode: null,
        locationCountry: 'PH',
        companyName: null,
        businessStyle: null,
        companyDesignation: null,
        tinNumber: null,
        password: null,
        confirmPassword: null,
        isSoleProp: false,
        isPartnerCorp: false,
        isCoop: false,
        isProf: false,
        otp: null,
        otpSource: null,
        otpValidity: null,
        termsAndConditions: false,
        subscribeMailingList: true,
      },
      showAdditionalTab: false,
      checkValidation: false,
      steps: [
        { title: 'Mobile Number Registration' },
        { title: 'Membership Type' },
        { title: 'Company Details' },
        { title: 'Personal Information' },
        { title: 'Contact Details' },
        { title: 'Password' },
        { title: 'File Requirements' },
        { title: 'Terms and Agreements' },
      ],
      title: 'Current Step Title',
      tinValidated: true,
      tinValidatedFromModule: false,
      createMemberEndpoint: '/api/v2/clp_member_accounts/create',
    };
  },
  methods: {
    reOtpSucess() {
      const reOtpRef = this.$refs.reOtp;
      this.formData.mobileNo = reOtpRef.mobileNumber;
      this.formData.otp = reOtpRef.otp;
      this.formData.otpSource = reOtpRef.otpSource;
      this.formData.otpValidity = reOtpRef.otpValidity;
      this.reOtpModal = false;
    },
    verifyValue(val) {
      this.checkValidation = val;
    },
    tinVerified() {
      this.tinValidatedFromModule = true;
      this.tinValidated = true;
    },
    closeModal() {
      this.$router.push(`login`);
    },
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    increaseCurrentStep() {
      const FILE_REQ = 6;
      const SET_PASSWORD = 5;
      const CONTACT_INFO = 4;
      const PESONAL_INFO = 3;
      const COMPANY_DETAILS = 2;
      const SET_MEMBER_TYPE = 1;
      const MOBILE_NO = 0;

      const current = this.currentStep;
      let proceedNext = true;

      if (current === FILE_REQ) {
        const isOk = this.fileRequirements();
        if (!isOk) {
          proceedNext = false;
        }
      }
      if (current === SET_PASSWORD) {
        const isOk = this.setPassword();
        if (!isOk) {
          proceedNext = false;
        }
      }

      if (current === CONTACT_INFO) {
        const isOk = this.setContactInformation();
        if (!isOk) {
          proceedNext = false;
        }
      }
      if (current === PESONAL_INFO) {
        const isOk = this.setPersonalInformation();
        if (!isOk) {
          proceedNext = false;
        }
      }
      if (current === COMPANY_DETAILS) {
        const isOk = this.setCompanyDetails();
        if (!isOk) {
          proceedNext = false;
        }
        if (!(this.tinValidatedFromModule && this.tinValidated)) {
          proceedNext = false;
        }
      }
      if (current === SET_MEMBER_TYPE) {
        const isOk = this.setMemberType();
        if (!isOk) {
          proceedNext = false;
        } else {
          if (!this.showAdditionalTab) {
            this.currentStep++;
          } else {
            this.tinValidatedFromModule = false;
            this.tinValidated = false;
          }
        }
      }

      if (current === MOBILE_NO) this.setMobileNo();

      if (proceedNext) {
        if (current + 1 < this.currentStepLimit) {
          this.currentStep++;
        }
      }
    },
    decreaseCurrentStep() {
      const current = this.currentStep;
      if (current === 3) {
        if (!this.showAdditionalTab) {
          this.currentStep--;
        }
      }

      if (current === 2) {
        this.tinValidated = true;
      }

      if (!(current - 1 < 0)) {
        this.currentStep--;
      }
    },
    setMobileNo() {
      const mobileNumberRef = this.$refs.mobileNo;
      this.formData.mobileNo = mobileNumberRef.mobileNumber;
      this.formData.otp = mobileNumberRef.otp;
      this.formData.otpSource = mobileNumberRef.otpSource;
      this.formData.otpValidity = mobileNumberRef.otpValidity;
    },
    setMemberType() {
      const memberTypeRef = this.$refs.memberTypes;
      memberTypeRef.$v.formData.$touch();
      if (memberTypeRef.$v.formData.$invalid) {
        return false;
      }

      this.formData.memberTypeId = memberTypeRef.formData.memberType;
      this.formData.subMemberTypeId = memberTypeRef.formData.subMemberType;
      this.formData.chapterTypeId = memberTypeRef.formData.chapterType;
      if (memberTypeRef.formData.memberType === memberTypeRef.corporateRetailInfo.id) {
        this.showAdditionalTab = true;
        this.formData.isSoleProp = false;
        this.formData.isPartnerCorp = false;
        this.formData.isCoop = false;

        if (memberTypeRef.formData.subMemberType === memberTypeRef.solePropInfo.id) {
          this.formData.isSoleProp = true;
        }
        if (memberTypeRef.formData.subMemberType === memberTypeRef.partnerCorpInfo.id) {
          this.formData.isPartnerCorp = true;
        }

        if (memberTypeRef.formData.subMemberType === memberTypeRef.coopInfo.id) {
          this.formData.isCoop = true;
        }
      } else {
        this.showAdditionalTab = false;
        this.formData.companyDesignation = null;
        this.formData.companyName = null;
        this.formData.businessStyle = null;
        this.formData.isSoleProp = false;
        this.formData.isPartnerCorp = false;
        this.formData.isCoop = false;
        this.formData.isProf = false;
        this.formData.tinNumber = null;
        this.tinValidated = true;
        this.tinValidatedFromModule = false;

        if (memberTypeRef.formData.memberType === memberTypeRef.professionalInfo.id) {
          this.formData.isProf = true;
          this.formData.tinNumber = memberTypeRef.formData.tinNumber;
        }
      }
      return true;
    },
    setPersonalInformation() {
      const personalInfoRef = this.$refs.personalInfo;
      personalInfoRef.$v.formData.$touch();
      console.table({ invalid: personalInfoRef.$v.formData.$invalid });
      if (personalInfoRef.$v.formData.$invalid) {
        return false;
      }
      this.formData.firstName = personalInfoRef.formData.firstName;
      this.formData.middleName = personalInfoRef.formData.middleName;
      this.formData.lastName = personalInfoRef.formData.lastName;
      this.formData.lastNameSuffix = personalInfoRef.formData.lastNameSuffix || null;
      this.formData.nickName = personalInfoRef.formData.nickName || null;
      this.formData.gender = personalInfoRef.formData.gender;
      this.formData.birthDay = personalInfoRef.formData.birthDay;
      this.formData.email = personalInfoRef.formData.email;
      return true;
    },
    setContactInformation() {
      const addressRef = this.$refs.address;
      addressRef.$v.formData.$touch();

      if (addressRef.$v.formData.$invalid) {
        return false;
      }
      this.formData.locationUnit = addressRef.formData.unit;
      this.formData.locationStreet = addressRef.formData.street;
      this.formData.locationBarangay = addressRef.formData.barangay.value;
      this.formData.barangayCode = addressRef.formData.barangay.code;
      this.formData.locationCity = addressRef.formData.city.value;
      this.formData.cityCode = addressRef.formData.city.code;
      this.formData.locationMunicipality = addressRef.formData.municipality.value;
      this.formData.municipalityCode = addressRef.formData.municipality.code;
      this.formData.locationProvince = addressRef.formData.province.value;
      this.formData.provinceCode = addressRef.formData.province.code;
      this.formData.locationRegion = addressRef.formData.region.value;
      this.formData.regionCode = addressRef.formData.region.code;
      return true;
    },

    setCompanyDetails() {
      const companyDetailsRef = this.$refs.companyDetails;
      companyDetailsRef.$v.formData.$touch();

      if (companyDetailsRef.$v.formData.$invalid) {
        return false;
      }
      this.formData.companyName = companyDetailsRef.formData.companyName;
      this.formData.businessStyle = companyDetailsRef.formData.businessStyle;
      this.formData.companyDesignation = companyDetailsRef.formData.companyDesignation;
      this.formData.tinNumber = companyDetailsRef.formData.tinNumber;
      return true;
    },
    fileRequirements() {
      const uploadDocumentsRef = this.$refs.uploadDocuments;
      const files = uploadDocumentsRef.formData.files;

      let x = 0;
      let incomplete = false;
      let isValid = false;
      while (x < files.length) {
        const current = files[x];
        if (current.is_required === 1 && (!current.file || current.file.length === 0)) {
          current.error = true;
          this.$refs.uploadDocuments.fetchFormData({ ...this.formData, files });
          isValid = false;
        }

        if (!(this.formData.isCoop && this.formData.optionalFilesCode.includes(files[x].code))) {
          if (files[x].file.length === 0) {
            incomplete = true;
          }
        }
        x++;

        if (incomplete && !isValid) {
          return false;
        }
        isValid = true;
      }

      if (isValid) {
        this.formData.files = uploadDocumentsRef.formData.files;

        return true;
      }
    },

    setPassword() {
      const setPasswordRef = this.$refs.setPassword;
      setPasswordRef.$v.formData.$touch();

      if (setPasswordRef.$v.formData.$invalid) {
        this.isPasswordValid = false;
        return false;
      }
      this.formData.password = setPasswordRef.formData.password;
      this.formData.confirmPassword = setPasswordRef.formData.repassword;

      this.isPasswordValid = true;
      return true;
    },
    async createMember() {
      this.createLoading = true;
      try {
        const otpValidity = moment(this.formData.otpValidity);
        const now = moment(new Date());
        const otpIsValid = otpValidity.isAfter(now);
        if (!otpIsValid) {
          this.reOtpModal = true;
          this.createLoading = false;
          return 0;
        }

        const {
          account_id: accountId,
          membership_program_id: membershipProgramId,
          id: sitePageId,
        } = this.clpSitePageSettings;

        const { year, month, day } = {
          year: this.formData.birthDay.format('YYYY'),
          month: this.formData.birthDay.format('MM'),
          day: this.formData.birthDay.format('DD'),
        };

        const files = this.formData.files;
        let memberUploads = [];
        let x = 0;
        while (x < files.length) {
          // generate signed url
          if (files[x].file.length > 0) {
            const { signedUrl, url } = await this.genSignedUrl(files[x].file);
            console.table({ signedUrl, url });
            const path = await this.s3Upload(files[x].file, signedUrl);
            console.log(path);
            // upload file
            memberUploads.push({
              member_upload_type_id: files[x].id,
              s3_url: url,
            });
          }
          x++;
        }
        const payload = {
          member: {
            account_id: accountId,
            membership_program_id: membershipProgramId,
            member_type_id: this.formData.memberTypeId,
            sub_member_type_id: this.formData.subMemberTypeId,
            chapter_type_id: this.formData.chapterTypeId,
            first_name: this.formData.firstName,
            last_name: this.formData.lastName,
            middle_name: this.formData.middleName,
            last_name_suffix: this.formData.lastNameSuffix,
            nick_name: this.formData.nickName,
            mobile_number: `+63${this.formData.mobileNo}`,
            email: this.formData.email,
            location_unit: this.formData.locationUnit,
            location_street: this.formData.locationStreet,
            location_barangay: this.formData.locationBarangay,
            barangay_code: this.formData.barangayCode,
            location_city: this.formData.locationCity,
            city_code: this.formData.cityCode,
            location_municipality: this.formData.locationMunicipality,
            municipality_code: this.formData.municipalityCode,
            location_province: this.formData.locationProvince,
            province_code: this.formData.provinceCode,
            location_region: this.formData.locationRegion,
            region_code: this.formData.regionCode,
            location_country: this.formData.locationCountry,
            gender: this.formData.gender,
            birth_month: `1990-${month}-01`,
            birth_year: `${year}-01-01`,
            birth_day: `1990-01-${day}`,
            company_name: this.formData.companyName,
            company_tin: this.formData.tinNumber,
            company_role: this.formData.companyDesignation,
            business_style: this.formData.businessStyle,
          },
          account: {
            site_page_id: sitePageId,
            password: this.formData.password,
            confirm_password: this.formData.confirmPassword,
          },
          otp: {
            otp_code: this.formData.otp,
            source: this.formData.otpSource,
          },
          member_uploads: memberUploads,
        };
        const createUrl = this.createMemberEndpoint;

        const createResponse = await HTTPRequest.postRequest(createUrl, payload);
        console.log('createResponse ', createResponse);
        const { status, message, error } = createResponse;
        console.log(message);
        console.log(error);
        console.log(status);
        if (error) {
          throw new Error(error);
        }
        let modalType;
        if (this.formData.isProf) {
          modalType = 'profModal';
        } else if (this.formData.isSoleProp || this.formData.isPartnerCorp || this.formData.isCoop) {
          modalType = 'corpModal';
        } else {
          modalType = 'retailModal';
        }

        this[modalType] = true;
      } catch (err) {
        console.log(err);
        this.$notification.error({
          message: err.message,
        });
      }
      this.createLoading = false;
    },
    changeCreateDisable(value) {
      this.canCreate = value;
    },
    changeEmailSubscribe(value) {
      this.formData.subscribeMailingList = value;
    },
    changeTermsAndCondition(value) {
      this.formData.termsAndConditions = value;
    },
    async genSignedUrl(file = []) {
      if (file && file.length > 0 && file[0] instanceof File) {
        try {
          const { name: fileName, type: fileType } = file[0];
          const genResult = await axios({
            method: 'POST',
            url: S3Api + '?account_name=cw' + '&profile=member-registration-requirements',
            headers: {
              'x-app-key': S3ApiKey,
            },
            data: JSON.stringify({
              fileName,
              fileType,
            }),
          });
          const { signedUrl, url } = genResult.data;
          return { signedUrl, url };
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },
    async s3Upload(file = [], url) {
      if (file && file.length > 0 && file[0] instanceof File) {
        const { type: fileType } = file[0];
        const readBufferFile = await this.readFileAsArrayBuffer(file[0]);
        const formData = new FormData();
        formData.append('file', readBufferFile);
        let filePath = null;
        try {
          const upload = await axios.put(url, readBufferFile, {
            headers: {
              'Content-Type': fileType,
            },
          });

          console.log('uploadResponse ', upload);

          if (upload.status === 200) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
    onPasswordTyping() {
      this.setPassword(); // This updates this.isPasswordValid dynamically
    },
  },
  computed: {
    currentStepLimit() {
      return this.steps.length;
    },
  },
  created() {
    this.title = this.steps[0].title;
  },
  beforeUnmount() {
    // Clean up the event listener
    window.removeEventListener('resize', this.updateWidth);
  },
  mounted() {
    const stepFromQuery = parseInt(this.$route.query.currentStep);
    if (stepFromQuery) {
      this.currentStep = stepFromQuery;
    }
    window.addEventListener('resize', this.updateWidth);
  },
  watch: {
    currentStep: function (val) {
      this.title = this.steps[val].title;
    },
  },
};
</script>
